import { logEvent, analytics } from '../firebase.js';
import { useLocale } from '../hooks/useLocale.jsx';

// useAppGate 가 막았을 때 뜨는 시트.
//
// 처음엔 "웹에서 계속" 탈출구를 뒀는데 뺐다. GA4 90일 기준 모바일 웹은 사용자
// 479명(36.9%)으로 최대 집단이지만 생성/사용자가 0.23 이다 — iOS 앱 2.03,
// 안드로이드 앱 1.68 의 1/9 수준. 구경하고 떠나는 사람들이라 탈출구로 지킬
// 게 거의 없었고, 그중 한 명이 설치하면 가치가 8배가 된다.
//
// 데스크톱은 이 시트 자체가 안 뜬다 (useAppGate) — 생성/사용자 0.59 로 모바일
// 웹보다 잘 쓰는데 설치할 기기가 없다. 거기까지 막으면 순손실이다.
export function AppGateModal({ open, onClose, storeUrl, surface }) {
  const { t } = useLocale();
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box app-gate" onClick={e => e.stopPropagation()}>
        <img className="app-gate-icon" src="/icons/icon-192.webp" alt="" />
        <h3>{t('appGateTitle')}</h3>
        <p>{t('appGateDesc')}</p>
        <a
          className="btn btn-primary btn-block"
          href={storeUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => logEvent(analytics, 'app_gate_store_clicked', { surface })}
        >
          {t('appGateCta')}
        </a>
        {/* 닫기는 남긴다 — 실수로 눌렀을 때 빠져나갈 길까지 막으면 그건
            게이트가 아니라 고장이다. 다만 웹으로 이어서 하는 경로는 없다. */}
        <button
          className="app-gate-dismiss"
          onClick={() => {
            logEvent(analytics, 'app_gate_dismissed', { surface });
            onClose();
          }}
        >
          {t('appGateNotNow')}
        </button>
      </div>
    </div>
  );
}
